<!--
 * @Description:
 * @Date: 2020-11-06 16:38:28
-->
<template>
  <div>
    <table-render
      ref="tableRender"
      :config="config"
      :key="showUploadInvoice"
      :propData="{ query: {} }"
    />
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import config, { uploadI } from './config';

import { invoiceNew } from '@/api/ajax';

export default {
  name: 'invoiceTable',
  provide() {
    return {
      itemData: this.options
    };
  },
  data() {
    return {
      showUploadInvoice: false,
      options: {
        data: {}
      }
    };
  },
  computed: {
    config() {
      if (this.showUploadInvoice) {
        return [...config, uploadI];
      } else {
        return config;
      }
    }
  },
  components: { tableRender },
  created() {
    this.showUploadInvoice = this.$store.getters.isMaster;
    invoiceNew.invoiceCheck().then(({ data: { data } }) => {
      if (!data) {
        this.config[1].childMenu[0].moreBtnArr = [];
      }
    });
  }
};
</script>

<style scoped lang="scss"></style>
